import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { Inject, Service } from 'vue-di-container';
import { AddProviderRequestModel } from './AddProviderRequestModel';
import $ from 'jquery';

@Service()
export default class AddProviderRequestService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    public async sendOTP(request: {
        email: string;
        recaptchaToken: string;
        name: string;
        enterpriseUnifiedNumber: string;
        accreditationNumber: string;
        taxNumber: string;
        username: string;
        useremail: string;
    }) {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/providerrequest/send-otp';
            const result = await this.axiosService.axiosInstance.post(url, request);
            this.loaderService.HideLoader();
            return result.data;
        } catch (error) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async verifyAndSubmit(request: {
        providerRequest: AddProviderRequestModel;
        data: string;
        otpExpiresAt: string;
        otp: string;
        recaptchaToken: string;
    }) {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/providerrequest/verify-and-submit';
            const result = await this.axiosService.axiosInstance.post(url, request);
            this.loaderService.HideLoader();
            return result.data;
        } catch (error) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public getRecaptchaSiteKey(): string {
        try {
            const url = 'api/login/getRecaptchaSiteKey';
            const response = $.ajax({
                url: url,
                method: 'GET',
                async: false,
            }).responseText;
            return response;
        } catch (error) {
            return '';
        }
    }
}
